:root {
  --sentColor: #0b93f6;
  --receiveColor: #e5e5ea;
  --bg: #fff;
}

.shared {
  position: relative;
  max-width: 255px;
  margin-bottom: 15px;
  padding: 10px 20px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  line-height: 24px;
  word-wrap: break-word;
  border-radius: 25px;

  &:before {
    width: 20px;
  }

  &:after {
    width: 10px;
    background-color: var(--bg);
  }

  &:before,
  &:after {
    position: absolute;
    bottom: 0;
    height: 25px;
    transition: transform 200ms ease-out;
    content: '';
  }
}

.noTail {
  margin-bottom: 2px;

  &:before,
  &:after {
    opacity: 0;
  }
}

.sent {
  align-self: flex-end;
  color: white;
  background: var(--sentColor);
  margin-right: 10px;

  &:before {
    right: -7px;
    background-color: var(--sentColor);
    border-bottom-left-radius: 16px 14px;
  }

  &:after {
    right: -10px;
    border-bottom-left-radius: 10px;
  }
}

.sent:has(+ .sent) {
  margin-bottom: 2px;

  &:before,
  &:after {
    opacity: 0;
  }
}

.received {
  align-self: flex-start;
  color: black;
  background: var(--receiveColor);
  margin-left: 10px;

  &:before {
    left: -7px;
    background-color: var(--receiveColor);
    border-bottom-right-radius: 16px 14px;
  }

  &:after {
    left: -10px;
    border-bottom-right-radius: 10px;
  }
}

.received:has(+ .received) {
  margin-bottom: 2px;

  &:before,
  &:after {
    opacity: 0;
  }
}
